<template>
  <div class="invite-main-content">
    <login-layout :title="layoutTit">
      <div class="inivite-join-result">
        <a-form>
          <a-form-item>
            <div style="text-align:center">
              <span>{{ inviteuser }}</span>{{ $t('message["1587"]') }}
            </div>
          </a-form-item>
          <a-form-item>
            <div class="project-name">
              <template v-if="projectname">
                <h2 class="invite-company-name">
                  {{ comname }}-{{ projectname }}
                </h2>
              </template>
              <template v-else>
                <h2 class="invite-company-name">
                  {{ comname }}
                </h2>
              </template>
            </div>
          </a-form-item>
          <a-form-item>
            <!-- 并成为该组织<strong>管理员</strong> -->
            <div class="isnoJoin">
              <p>{{ $t('message["1096"]') }}？</p>
            </div>
          </a-form-item>
          <a-form-item class="invite-re-btn">
            <a-button
              class="login-btn"
              type="primary"
              @click="submitForm"
            >
              {{ $t('message["597"]') }}
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button
              class="login-btn"
              @click="resetForm"
            >
              {{ $t('message["1448"]') }}
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </login-layout>
  </div>
</template>
<script>
import LoginLayout from '@/components/pc/organization/invite/Link'
import { mapActions, mapState } from 'vuex'
export default {
  'name': '',
  components: {
    LoginLayout
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([]),
    comname () {
      return this.$route.query.comname
    },
    inviteuser () {
      return this.$route.query.inviteuser
    },
    invitecode () {
      return this.$route.query.invitecode
    },
    projectname () {
      return this.$route.query.projectname
    },
    layoutTit () {
      return this.$t('message["1381"]')
    }
  },
  methods: {
    ...mapActions('organization/inviteJoin', ['ajaxLastJoin']),
    async submitForm (formName) {
      const chain = await this.ajaxLastJoin()
      chain.params({ invitecode: this.$route.query.invitecode })
        .onSuccess((raw, res) => {
          this.$router.push({ name: 'OrgIndex' })
        })
        .fetch()
    },
    resetForm (formName) {
      // this.$router.push({ path: '/organization/index' })
      this.$router.push({ name: 'OrgIndex' })
    }
  }
}
</script>

<style lang="scss" scoped >
.inivite-join-result {
  .login-btn {
    display: block;
    width: 100%;
  }

  .el-form-item {
    margin: 8px 0;
    text-align: center;
  }

  .el-form-item__content {
    line-height: 24px;

    .invite-company-name {
      line-height: 32px;
      font-size: 18px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: center;
      color: #333333;
    }
  }

  .invite-re-btn {
    margin: 48px 0 24px;
  }
}
.isnoJoin {
  text-align: center;
  p {
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    color: #666666;
  }
}
.project-name {
  text-align: center;
}
.invite-main-content {
  width: 1440px;
  height: 900px;
  background-color: #f5f6f7;
  margin: 0 auto;
  padding-top: 100px;
  .login-panel {
    width: 400px;
    height: 536px;
    border-radius: 8px;
    border: solid 1px #ebebeb;
    background-color: #ffffff;
    text-align: center;
    margin-left: 520px;
    .join-content-div {
      width: 320px;
      height: 32px;
      border-radius: 4px;
      border: solid 1px #5077aa;
      background-image: linear-gradient(to top, #5077aa, #608fcc);
      margin-left: 40px;
      line-height: 32px;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      color: #ffffff;
      cursor: pointer;
    }
    .username-div,
    .securitycode-div {
      width: 320px;
      margin-left: 40px;
      margin-bottom: 24px;
      .code-span {
        position: absolute;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: normal;
        text-align: right;
        color: #5077aa;
        margin-top: 10px;
        cursor: pointer;
        margin-left: -80px;
      }
      .no-line {
        outline: none;
      }
    }
    .project-name {
      height: 24px;
      font-size: 14px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.71;
      letter-spacing: normal;
      text-align: center;
      margin-top: 56px;
      margin-bottom: 24px;
      color: #333333;
    }
    .subtitle-content {
      height: 88px;
      margin-top: 40px;
      text-align: center;
      img {
        width: 48px;
        height: 48px;
      }
      p {
        height: 40px;
        font-size: 20px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 2;
        letter-spacing: normal;
        text-align: center;
        color: #333333;
      }
    }
  }
}
.invite-login-subtitle {
  height: 24px;
  line-height: 24px;
  padding: 8px 0;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;

  span {
    margin: 0 10px;
  }
}
.parent-code {
  width: 100%;
  display: table;
  .children-code {
    vertical-align: middle;
    display: table-cell;
    &:last-child {
      padding-left: 20px;
    }
  }
}
.join-btn-div {
  text-align: center;
}
.invite-login {
  padding-top: 30px;

  .login-btn {
    display: block;
    width: 100%;
  }

  .password-box {
    position: relative;

    .find-pwd-link {
      position: absolute;
      right: 12px;
      top: 0;

      .js-code-bbt {
        background: none;
        border: 0;
        color: #5077aa;
        padding: 0;
      }

      .el-button.is-disabled {
        color: #c0c4df;
        background: none;
      }
    }
  }
}
</style>
